import React from 'react';
import { useSelector } from 'react-redux';

import { getWorkspaceTeammatesIds } from 'Shared/selectors/workspace';
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { getRecurringMeetingWithoutWorkspaces } from 'Shared/selectors/user';
import { isEmptyString, fullNameFromEmail } from 'Shared/helpers';
import { getMembersWhoHaveNotTeammateYet } from 'Shared/selectors/members';
import { getBaseTeammateSuggestionList } from 'Shared/components/modals/SimpleAddWorkspaceModals/SuggestionsSection/utils';
import SuggestedTeammateFromCalendar from 'Shared/components/modals/SimpleAddWorkspaceModals/SuggestionsSection/SuggestedTeammateFromCalendar/SuggestedTeammateFromCalendar';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

import './WorkspaceTeammateSuggestions.scss';

type Props = {
  identif: string;
  formValues: {};
  isSuggestedListOpened: boolean;
  workspaceName: string;
  onSuggestionClick: Function;
};

function WorkspaceTeammateSuggestions({
  identif,
  formValues,
  isSuggestedListOpened,
  workspaceName,
  onSuggestionClick,
}: Props) {
  const { id: currentUserId } = useCurrentUser();
  const members = useSelector(getMembersWhoHaveNotTeammateYet);
  const { tr } = useTranslation();

  const teammateIds = useDeepEqualSelector(getWorkspaceTeammatesIds);
  const recurringMeetingsWithoutWorkspaces = useDeepEqualSelector(getRecurringMeetingWithoutWorkspaces());
  const teammateSuggestionList = getBaseTeammateSuggestionList({
    formValues,
    recurringMeetingsWithoutWorkspaces,
    currentUserId,
    teammateIds,
    members,
  });

  const renderList = teammateSuggestionList.filter(({ person, recurringMeeting }) => {
    const foundByPersonName =
      (person.fullName && person.fullName.toLowerCase().includes(workspaceName.toLowerCase())) ||
      (person.email && person.email.toLowerCase().includes(workspaceName.toLowerCase()));

    const foundByMeetingName =
      recurringMeeting &&
      workspaceName
        .toLowerCase()
        .split(' ')
        .filter(n => !isEmptyString(n))
        .some(word => recurringMeeting.name.toLowerCase().includes(word));

    return foundByPersonName || foundByMeetingName;
  });

  const isRender = isSuggestedListOpened && !isEmptyString(workspaceName) && renderList.length;

  if (!isRender) return null;

  return (
    <div className="workspace-teammate-suggestions position-relative w-100">
      <div className="workspace-teammate-suggestions-container position-absolute scrollbar w-100">
        <div className="workspace-teammate-suggestions-title p-2">{tr('perform.workspace.suggestions.title')}</div>

        {renderList.map(({ recurringMeeting, person, suggestionType }) => (
          <SuggestedTeammateFromCalendar
            key={person.email}
            recurringMeeting={recurringMeeting}
            person={person}
            suggestionType={suggestionType}
            onClick={({ recurringMeetingId, email, fullName }) => {
              onSuggestionClick({
                identif,
                fullName: fullName || fullNameFromEmail(email) || '',
                email,
                recurringMeetingId,
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default WorkspaceTeammateSuggestions;
